import gql from "graphql-tag";

export const GET_ACTIVE_BELL_NOTIFICATIONS = gql`
  {
    getNotificationsBellCount {
      Active
    }
  }
`;
